// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  alluserloading: false,
  error: false,
  loginStatus: {
    data: null,
  },
  getUserslistStatus: { data: null },
  getAllUserslistStatus: { data: null },
  getSingleUserStatus: { data: null },
  editUsersStatus: { data: null },
  deleteUsersStatus: { data: null },
};
